import React from 'react';

import { Box, Tabs } from '@parspec/pixel';

import { TAB_OPTIONS } from '../../ImportMoreProducts/shared/constants';

interface TabsListProps {
    pathName: string;
    handleTabChange: (tabValue: string) => void;
}

const TabsList: React.FC<TabsListProps> = ({ pathName, handleTabChange }) => {
    return (
        <Box display="flex" flexDirection="column" flex={1} minHeight={0}>
            <Box>
                <Tabs onChange={handleTabChange} options={TAB_OPTIONS} selectedTab={pathName} />
            </Box>
        </Box>
    );
};

export default TabsList;
